<style scoped>
.popup-global-position.k-simple-modal {
  max-height: calc(100vh - 60px);
  width: 90vw;
  top: 30px !important;
  transform: translate(-50%, 0%);
  max-height: calc(100vh - 60px) !important;
  overflow: auto;
  position: fixed;
}

#simple-modal.card-img-overlay {
  position: fixed !important;
}

.close {
  text-align: right;
  margin-bottom: 20px;
  cursor: pointer;
  position: absolute;
  top: 20px;
  right: 20px;
}

.card-body {
  position: relative;
}

pre{
  white-space: break-spaces;
}

.p-tab {
  border-radius: 0 !important;
}
</style>

<template>
  <div v-if="show" id="simple-modal-overlay" class="k-overlay" @click="annulla"></div>
  <div v-if="show" id="simple-modal" class="card-img-overlay popup-global-position k-simple-modal">

    <div class="card mb-4">

      <div class="card-body p-5">
        <div class="close" @click="annulla()">
          <i class="pi pi-times" style="font-size: 20px"></i>
        </div>

        <DataTable  paginator :rows="15" v-model:filters="filters" :value="allNotifiche" :globalFilterFields="['idTicket', 'idCreatedBy', 'idPM', 'titoloLavoro', 'titoloAttivita']">
          <template #header>
            <div class="row">
              <div class="col-6"><span class="text-xl font-bold">Tutte le notifiche</span></div>
              <div class="col-6" style="text-align: right">
                <IconField>
                  <InputText v-model="filters['global'].value" placeholder="Cerca" />
                </IconField>
              </div>
            </div>
          </template>
          <Column header="" style="width: 180px">
            <template #body="slotProps">
              <div class="bottoni-notifica">
                <CustomButton title="Viaualizza dettagli" class="dettaglio" @click="dettaglioNotifica(slotProps)" icon="pi pi-eye" rounded raised />
                <CustomButton title="Assegna a nuovo PM" class="sposta" icon="pi pi-directions-alt" rounded raised @click="spostaNotifica(slotProps)"> </CustomButton>
              </div>

            </template>
          </Column>
          <Column header="Data creazione" style="width:150px">
            <template #body="slotProps">
              <p>
                {{ slotProps.data.createdAt }}
              </p>
            </template>
          </Column>
          <Column field="idTicket"  style="max-width:100px" header="Id Ticket">
            <template #body="slotProps">
              <p class="m0">
                {{ slotProps.data?.idTicket }}
              </p>
            </template>
          </Column>
          <Column style="max-width:150px" header="Esecutore">
            <template #body="slotProps">
              <p class="m0">
                {{ slotProps?.data?.idCreatedBy }}
              </p>
            </template>
          </Column>
          <Column style="max-width:150px" header="PM responsabile">
            <template #body="slotProps">
              <p class="m0">
                {{slotProps?.data?.idPM }}
              </p>
            </template>
          </Column>
          <Column header="Stato" style="width:150px">
            <template #body="slotProps">
              <p>
                {{ slotProps.data.vecchioStato }} -> {{ slotProps.data.nuovoStato }}
              </p>
            </template>
          </Column>

          <Column  style="max-width:150px" header="Lavoro">
            <template #body="slotProps">
              <p class="m0">
                {{ slotProps.data?.titoloLavoro }}
              </p>
            </template>
          </Column>
          <Column style="max-width:150px" header="Attività">
            <template #body="slotProps">
              <p class="m0">
                {{ slotProps.data?.titoloAttivita }}
              </p>
            </template>
          </Column>

          <Column style="max-width:150px" field="messaggio" header="Messaggio">
            <template #body="slotProps">
              <p class="messaggio-notifica">
                {{ slotProps.data.messaggio }}
              </p>
            </template>
          </Column>

          <Column header="DOD">
            <template #body="slotProps">
              <p>
                {{ slotProps.data.dodTaskSprint }}
              </p>
            </template>
          </Column>

        </DataTable>
      </div>
    </div>
  </div>

  <CustomDialog v-model:visible="showCambiaManager" modal header="Cambia PM per il TS associato a questa notifica" :style="{ width: '700px' }">
    <div class="row" style="margin-top: 20px">

      <div class="col-12">
        <div class="flex flex-col gap-1">
          <FloatLabel class="w-full md:w-56" variant="on">
            <CustomSelect filter v-model="nuovoManager" :options="esecutori" optionLabel="descrizione" optionValue="id_account" :loading="esecutori.length<=0"   />
            <!--            <Message v-if="$form.city?.invalid" severity="error" size="small" variant="simple">{{ $form.city.error.message }}</Message>-->
            <label for="over_label">Manager</label>
          </FloatLabel>
        </div>
      </div>
    </div>

    <div class="flex justify-end gap-2" style="grid-gap: 40px; display: flex; margin-top: 40px">
      <CustomButton type="button" label="Annulla" severity="secondary" @click="showCambiaManager=false"></CustomButton>
      <CustomButton type="button" label="Conferma" severity="primary" @click="confermaCambioManager"></CustomButton>
    </div>
  </CustomDialog>


</template>

<script>
import * as $ from 'jquery';
import CustomButton from "primevue/button";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import { FilterMatchMode } from '@primevue/core/api';
import InputText from 'primevue/inputtext';
import CustomDialog from "primevue/dialog";
import CustomSelect from "primevue/select";
import FloatLabel from "primevue/floatlabel";
export default {
  name: "KModalTutteLeNotifiche",
  components: {CustomSelect, CustomDialog, DataTable,Column,CustomButton,InputText, FloatLabel },

  data() {
    return {
      allNotifiche:[],
      showCambiaManager:false,
      show:false,
      filters: {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        idTicket: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      },
    }
  },
  created() {
    $(document).keyup(function (e) {
      if (e.key === "Escape" && this.show) {
        this.annulla()
      }
    }.bind(this));
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'viewModalAllNotifiche') {
        $('html').css('overflow', 'hidden')
        this.show = true;
        let notifiche=mutation.payload;


        notifiche.forEach(not=>{
          if(not.idCreatedBy){
            not.idCreatedBy=this.getEsecutore(not.idCreatedBy);
          }
          if(not.idPM)
            not.idPM=this.getEsecutore(not.idPM);
        });

        this.allNotifiche=notifiche;
      }
      if(mutation.type==='reopenTutteLeNotifiche'){
        this.show=true
      }
    });

  },
  methods: {
    annulla() {
      this.show = false;
      this.allNotifiche=[]
      $('html').css('overflow', 'auto')
    },

    dettaglioNotifica(not){
      let notifica=not.data;
      let lavoro={};
      let attivita={};
      if(notifica.idTicketParent && notifica.idTicketParent>0){
        let lav=this.$store.getters.getLavoroTicket(notifica.idTicketParent);
        if(lav && lav.length>0){
          lavoro={
            titolo:lav[0].titolo,
            descrizione:lav[0].descrizione
          }
        }
      }

      if(notifica.idTicket && notifica.idTicket>0){
        let att=this.$store.getters.getTicket(notifica.idTicket);
        if(att && att.length>0){
          attivita={
            titolo:att[0].titolo + ' - '+att[0].id_ticket ,
            descrizione:att[0].descrizione
          }
        }
      }

      let esecutore=this.getEsecutore(notifica.idCreatedBy);
      this.$store.dispatch("showDettaglioNotifica", {
        notifica: { ...notifica },
        lavoro:{...lavoro},
        attivita:{...attivita},
        esecutore:esecutore,
        fromTutteLeNotifiche:true,
        titolo: 'Dettaglio notifica creata da '+ esecutore +' il '+notifica.createdAt,
      });
      this.show=false;
    },



    getEsecutore(idEsecutore){
      if(!idEsecutore){
        return ''
      }
      if(idEsecutore==-1){
        return 'SYS'
      }
      let esecutore=this.$store.getters.getEsecutoriFilter(""+idEsecutore);
      if(!esecutore || esecutore.length <= 0){
        return ''
      }else{
        return esecutore[0]?.descrizione;
      }
    },

    spostaNotifica(not){
      let notifica=not.data;
      this.showCambiaManager=true;
      this.nuovoManager=notifica.idPM+"";
      this.esecutori=this.$store.getters.getEsecutori();
      this.idTaskNotifica=notifica.idTaskSprint;
    },
    confermaCambioManager(){
      this.$store.dispatch("cambiaManagerNotifica", {
        idTaskSprint:this.idTaskNotifica,
        idPmForzato:this.nuovoManager
      });
      this.showCambiaManager=false;
    }
  }
}
</script>